module.exports = __webpack_public_path__ + "img/pnap-black.1b1773d7.svg";